import { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { faCogs, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SafeDatatable } from "../../../components/SafeDatatable";
//import ReactDatatable from "@ashvin27/react-datatable";

import { HeaderList } from "../../../components/HeaderList";
import { CustomModal } from "../../../components/Modal";

import { EventService } from "../../../services/event.service";
import { ToastService } from "../../../services/toast.service";
import { ErrorHandler } from "../../../services/errorHandler.service";

import { useTranslation } from 'react-i18next';
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";
import _ from 'lodash';
import TransporterService from "../../../services/transporter.service";
import { TransporterModel } from "../../../models/transporter.model";
import { LocaleModel } from "../../../models/locale.model";
import { BranchModel } from "../../../models/branch.model";
import LocaleService from "../../../services/locale.service";
import BranchService from "../../../services/branch.service";
import storageService from "../../../services/storage.service";
import { useHistory } from "react-router-dom";
import { ButtonClean, ButtonSearch } from "../../../components/buttons";
import UtilService from "../../../services/util.service";

const EventList = () => {
  const user = storageService.getUser();
  const { pathname } = useLocation();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();
  const [data, setData] = useState<DatasetModel>();
  const [showRemoveModal, setShowRemoveModal] = useState({
    id: 0,
    show: false,
    name: "",
    entity: null
  });
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)), dataset: 'event', filters: {
      transporter_id: [],
      branch_id: [],
      locale_id: [],
      reason: []
    },
    sort: {
      field: 'reason',
      orientation: 'asc'
    }
  });
  const [transporters, setTransporters] = useState<TransporterModel[]>();
  const [locales, setLocales] = useState<LocaleModel[]>();
  const [branches, setBranches] = useState<BranchModel[]>();
  const history = useHistory();

  const columns = [
    {
      key: "reason",
      text: t("EVENT.REASON"),
      align: "left",
      sortable: true,
    },
    {
      key: "action",
      text: t("ACTIONS"),
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <Dropdown className='btn-toolbar'>
              <Dropdown.Toggle
                as={Button}
                variant='primary'
                size='sm'
                className='me-2'>
                <FontAwesomeIcon icon={faCogs} className='me-2' />
              </Dropdown.Toggle>
              <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => history.push(`${pathname}/edit/${record.id}`)}>
                  <FontAwesomeIcon icon={faEdit} className='me-2' /> 
                  {(user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") ? (
                        t("VIEW")
                      ):
                        t("EDIT")
                  }
                </Dropdown.Item>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => actionRemove(record.id, record.reason, record)}
                  disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                  >
                  <FontAwesomeIcon icon={faTrash} className='me-2' /> {t('DELETE')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Fragment>
        );
      },
    },
  ];

  const getList = async (dataTable, datasetOverride = null) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetOverride ||dataset] };
    let dataSet = requestParams.datasets[0];

    if (dataTable !== null) {
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;

      dataSet.sort.field = columns[0].key;
    }

    let sort = requestParams.datasets[0].sort;
    if (!sort) {
        sort = requestParams.datasets[0].sort = {};
    }
    if (!sort.field || sort.field === null || sort.field.trim?.() === "") {
        sort.field = "reason";
    }
    if (!sort.orientation || sort.orientation === null || sort.orientation.trim?.() === "") {
        sort.orientation = "asc";
    }

    const response: any = await EventService.getList(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'event' }));
      setData(d);
    } else {
      requestParams.datasets[0].data = null;
      setData(requestParams.datasets[0]);
    }
    setLoading(false);
  };

  const handleSearch = async (event) => {
    if (event != null)
      event.preventDefault();

      const trimreason = dataset.filters.reason?.[0]?.trim() || "";

      const cleanedDataset = {
        ...dataset,
        filters: {
          ...dataset.filters,
          reason: [trimreason],
        },
      };

    await getList(null,cleanedDataset);
  };

  const tableChangeHandler = async (data) => {
    await getList(data);
  };

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
        if (flagClear)
        {
            handleSearch(null);
            setFlagClear(false);
        }
      }, [flagClear]);

  const handleClean = () => {
    setDataset({
      ...dataset, filters: {
        transporter_id: [],
        branch_id: [],
        locale_id: [],
        reason: []
      },
      sort: {
        field: "",
        orientation: ""
      }      
    });
    setFlagClear(true);
  };

  const actionRemove = (id, name, entity) => {
    setShowRemoveModal({ id: id, show: true, name: name, entity });
  };

  const handleCloseModal = () =>
    setShowRemoveModal({ id: 0, show: false, name: "", entity: null });


  const remove = async () => {
    if (showRemoveModal.id) {
      try {
        const response: any = await EventService.del(showRemoveModal.entity);
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t('EVENT.REMOVED'));
            await getList(null);
            handleClean();
            handleCloseModal();
          }
        }
      } catch (error) { }
    }
  };


  const initialize = async () => {
    await getList(null);

    TransporterService.getAll().then((response: any) => {
      if (response.success === true && response.result) {
        let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'transporter' }));

        const sort = Array.isArray(d?.data)
        ? d.data.sort((a, b) => a.fullName.localeCompare(b.fullName))
        : [];
        setTransporters(sort);
      } 
    });

    LocaleService.getAll().then((response: any) => {
      setLocales(response.result);
    });

    BranchService.getAll().then((response: any) => {
       if (response.success === true && response.result) {
        let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'branch' }));

        const sort = Array.isArray(d?.data)
        ? d.data.sort((a, b) => a.fullName.localeCompare(b.fullName))
        : [];
        setBranches(sort);
      } 
    });
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderList path={`${pathname}/add`} title={t(`EVENT.TITLE`)} disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />

      <CustomModal
        Title={t('DELETE')}
        Message={`${t('EVENT.REMOVE_ANSWER')} ${showRemoveModal ? showRemoveModal.name : ""}?`}
        close={handleCloseModal}
        cancel={t('CANCEL')}
        show={showRemoveModal ? showRemoveModal.show : false}>
        <Button variant='primary' onClick={remove}>
          {t('YES')}
        </Button>
      </CustomModal>
      <Form>
        <Form.Label>{t('FILTERS')}</Form.Label>
        <Row>
          <Col sm={12} md={4} lg={3}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name='reason'
                  id='reason'
                  type='text'
                  placeholder={t('EVENT.REASON')}
                  className='form-control'
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, reason: [e.target.value] } })
                  }}
                  value={dataset?.filters?.reason.length > 0 ? dataset.filters.reason[0] : ''}
                />
                <label htmlFor="reason">{t("EVENT.REASON")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.locale_id.length > 0 ? dataset.filters.locale_id[0] : ''}
                  onChange={(e) => {
                    if (e.target.value === '') {
                      setDataset({ ...dataset, filters: { ...dataset.filters, locale_id: [] } })
                    } else {
                      setDataset({ ...dataset, filters: { ...dataset.filters, locale_id: [Number(e.target.value)] } })
                    }
                  }}
                >
                  <option value=''>{t("EVENT.LOCALE")}</option>
                  {_.map(locales, (l: LocaleModel) => {
                    return <option key={l.id} value={l.id}>{l.name}</option>
                  })}
                </Form.Control>
                <label htmlFor="status">{t("EVENT.LOCALE")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={4} lg={2}> 
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.transporter_id.length > 0 ? dataset.filters.transporter_id[0] : ''}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, transporter_id: [Number(e.target.value)] } })
                  }}
                >
                  <option value=''>{t("EVENT.TRANSPORTERNAME")}</option>
                  {_.map(transporters, (l: TransporterModel) => {
                    return <option key={l.id} value={l.id}>{l.fullName}</option>
                  })}
                </Form.Control>
                <label htmlFor="status">{t("EVENT.TRANSPORTERNAME")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.branch_id.length > 0 ? dataset.filters.branch_id[0] : ''}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, branch_id: [Number(e.target.value)] } })
                  }}
                >
                  <option value=''>{t("EVENT.BRANCH")}</option>
                  {_.map(branches, (l: BranchModel) => {
                    return <option key={l.id} value={l.id}>{l.fullName}</option>
                  })}
                </Form.Control>
                <label htmlFor="status">{t("EVENT.BRANCH")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs="auto">
            <ButtonSearch onClick={handleSearch} />
          </Col>

          <Col xs="auto">
            <ButtonClean onClick={async (e) => {e.preventDefault(); handleClean();}} />
          </Col>
        </Row>
      </Form>
     
      <SafeDatatable
        key={flagClear ? "reset" : JSON.stringify(dataset.filters)}
        config={UtilService.verifyIdiomDataTable()}
        records={data?.data ? data?.data : []}
        columns={columns}
        dynamic={true}
        total_record={data?.pagination?.total_records ? data?.pagination?.total_records : 0}
        onChange={tableChangeHandler}
        className='table table-hover user-table align-items-center'
      />
    </>
  );
};

export default EventList;